import { Component, OnInit } from '@angular/core';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { ApiService } from '../../services/jrni/api.service';
import { environment } from '../../../environments/environment';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { ServicesService } from '../../services/jrni/services.service';

@Component({
  selector: 'app-deep-link',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss'],
})
export class DeepLinksComponent implements OnInit {
  childrenDepartments: [];
  pageTitle: string;
  faChevronRight = faChevronRight;
  guidanceMsg: string;

  selectedDepartment;
  servicePageText;
  servicesList: any = [];
  selectedService;
  location;

  constructor(
    private departmentService: DepartmentService,
    private datastoreService: DatastoreService,
    private servicesService: ServicesService,
    protected alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private availabilityService: AvailabilityService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    this.getDepartments();
  }

  async getDepartments() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params.location === undefined) {
      }
      if (params.location === undefined) {
        this.router.navigate(['/departments']);
        return;
      }
      // reset the restricted booking
      this.datastoreService.isRestrictedBooking = false;
      this.datastoreService.isRestrictedAsbestosBooking = false;
      this.datastoreService.isCommercialBooking = false;

      let parentDepartment = await this.departmentService.getParentDepartment();
      this.datastoreService.parentDepartment = parentDepartment;

      const pId = parentDepartment.id;
      const pClient = parentDepartment.self.split('://')[1].split('.')[0];
      const token: any = await this.apiService.getToken(pClient, pId);
      if (token) {
        environment.clientToken = token.token;
      }
      const config = await this.apiService.getConfig(pClient, pId);
      this.datastoreService.config = config;
      if (parentDepartment) {
        this.pageTitle = parentDepartment.extra.location_page_title;
        this.guidanceMsg = parentDepartment.extra.location_page_guidance_text;
      }

      this.datastoreService.parentDepartment = parentDepartment;

      this.datastoreService.extra = parentDepartment.extra;
      let departments = await this.departmentService.getChildDepartments(
        parentDepartment
      );
      const department = departments.find(
        (x) => x.id.toString() === params.location.toString()
      );
      this.selectDepartment(department);
      this.datastoreService.bookingForm = null;
      this.datastoreService.selectedDate = null;
      this.datastoreService.selectedSlot = null;
      this.availabilityService.setSelectedSlot(null);
      this.scrollToTop();
      this.spinner.show();

      // Use this.departmentService.getLocation() if the services are set on the children departments
      // Use this.departmentService.get() if the services are set on the parent department
      this.departmentService.get().then(
        async (selectedDepartment) => {
          if (selectedDepartment === undefined) {
            this.restartJourney();
          } else {
            this.selectedDepartment = selectedDepartment;
            console.log(this.selectedDepartment);
            // Get the configurable data
            let parentDepartment =
              await this.departmentService.getParentDepartment();
            console.log(parentDepartment);
            if (parentDepartment?.extra?.services_page_title) {
              this.pageTitle = parentDepartment.extra.services_page_title;
            } else if (this.selectedDepartment.hasOwnProperty('extra')) {
              // Set the title on the login page to the title from the business question
              this.selectedDepartment.extra.hasOwnProperty(
                'services_page_title'
              )
                ? (this.pageTitle =
                  this.selectedDepartment.extra.services_page_title)
                : (this.pageTitle = 'Services title not set');
              // Set the extra text on the page to the text taken from the business question
              this.selectedDepartment.extra.hasOwnProperty('services_page_text')
                ? (this.servicePageText =
                  this.selectedDepartment.extra.services_page_text)
                : null;
            }

            if (params.service) {
              this.getServices(params.service);
            } else {
              this.router.navigate(['/services']);
            }
          }
        },
        (err) => {
          this.alertService.error(
            this.translateService.instant('COMMON.GENERAL_ERR')
          );
          this.spinner.hide();
        }
      );
    });
  }

  selectDepartment(department) {
    this.departmentService.set(department);
    this.datastoreService.selectedDepartment = department;
    this.departmentService.setLocation(department);
    // If the department has the setting required login then navigate to login else to services page
    // if (department.hasOwnProperty('extra') && department.extra.hasOwnProperty('login_required')) {
    //   if (department.extra.login_required.toLowerCase() === 'yes') {
    //     this.router.navigate(['/login']);
    //   } else {
    //     if (department.extra.service_or_location_first.toLowerCase() === 'service') {
    //       this.router.navigate(['/services']);
    //     }
    //   }
    // }
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  // Get the available services on the selected department
  async getServices(serviceId) {
    let services = await this.servicesService.getServices(
      this.selectedDepartment
    );
    const service = services.find(
      (x) => x.id.toString() === serviceId.toString()
    );
    if (service) {
      this.selectService(service);
    } else {
      this.restartJourney();
    }
  }

  selectService(service) {
    this.selectedService = service;

    this.continue();
  }

  continue() {
    if (this.selectedService) {
      console.log(this.selectedService);
      this.servicesService.set(this.selectedService);
      this.router.navigate(['/calendar']);
    } else {
      this.alertService.warn('Please select a service before proceeding');

      this.scrollToTop();
    }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
